import { Box, Button, IconButton, CircularProgress, Typography } from '@mui/material';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { PRODUCT_FIELDS } from '../../utils/dashboardUtils';
import DashboardMultiSelect, { MENU_PAPER_LIGHT } from './DashboardMultiSelect';

const TOOLBAR_SLICER_SX = {
  bgcolor: 'rgba(255,255,255,0.15)',
  borderRadius: 1,
  color: '#fff',
  '.MuiOutlinedInput-notchedOutline': { border: 'none' },
  '.MuiSvgIcon-root': { color: '#fff' },
  '.MuiInputLabel-root': { color: '#fff' },
};

const DashboardToolbar = ({
  title, subtitle, variant = 'warranty',
  years, periods, yearOptions, periodOptions,
  onYearsChange, onPeriodsChange,
  periodLabel, onDownload, onRefresh, downloading, loading,
  products, onProductsChange, departments, onDepartmentsChange, departmentOptions,
}) => {
  const yearLabel = variant === 'warranty' ? 'Year Selection' : 'Year';

  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #4863A0 0%, #6b7fd7 100%)',
        borderRadius: 2, p: 2.5, mb: 2, color: '#fff',
        boxShadow: '0 4px 16px rgba(72,99,160,0.2)',
      }}
    >
      <Box display="flex" flexWrap="wrap" justifyContent="space-between" alignItems="flex-start" gap={2}>
        <Box>
          <Typography variant="h5" fontWeight={700}>{title}</Typography>
          <Typography variant="body2" sx={{ opacity: 0.9 }}>{subtitle}</Typography>
          <Typography variant="caption" sx={{ opacity: 0.8 }}>Showing: {periodLabel}</Typography>
        </Box>
        <Box display="flex" flexWrap="wrap" gap={1.5} alignItems="center">
          <DashboardMultiSelect
            label={yearLabel}
            value={years}
            options={yearOptions || []}
            onChange={onYearsChange}
            minWidth={variant === 'warranty' ? 130 : 118}
            sx={TOOLBAR_SLICER_SX}
            menuProps={MENU_PAPER_LIGHT}
          />
          <DashboardMultiSelect
            label="Period"
            value={periods}
            options={periodOptions || []}
            onChange={onPeriodsChange}
            minWidth={130}
            sx={TOOLBAR_SLICER_SX}
            menuProps={MENU_PAPER_LIGHT}
          />
          {onProductsChange && (
            <DashboardMultiSelect
              label="Product"
              value={products}
              options={PRODUCT_FIELDS.map((p) => ({ value: p, label: p }))}
              onChange={onProductsChange}
              minWidth={120}
              sx={TOOLBAR_SLICER_SX}
              menuProps={MENU_PAPER_LIGHT}
            />
          )}
          {onDepartmentsChange && (
            <DashboardMultiSelect
              label="Department"
              value={departments}
              options={(departmentOptions || []).map((d) => ({ value: d, label: d }))}
              onChange={onDepartmentsChange}
              minWidth={180}
              sx={TOOLBAR_SLICER_SX}
              menuProps={MENU_PAPER_LIGHT}
            />
          )}
          <Button variant="contained" startIcon={downloading ? <CircularProgress size={14} color="inherit" /> : <DownloadOutlinedIcon />}
            onClick={onDownload} disabled={downloading || loading}
            sx={{ bgcolor: '#fff', color: '#4863A0', fontWeight: 700, '&:hover': { bgcolor: '#f0f4ff' } }}>
            Download
          </Button>
          <IconButton onClick={onRefresh} disabled={loading} sx={{ color: '#fff' }} aria-label="Refresh">
            <RefreshOutlinedIcon />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardToolbar;
